import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getImgixUrl, siteTypesEnum } from '../../../helpers';
import { withBrand } from '../../../providers/BrandProvider';
import { withTranslation } from 'react-i18next';
import { Heading } from '../../styled/siteBuilderModules/sharedComponents';
import './PersonHeader.scss';
import { PersonRole } from './components/PersonRole';

const { COURSE } = siteTypesEnum();

export function PersonHeader(props) {
  const {
    data: {
      photo,
      displayHonorific,
      showType,
      honorific,
      forename,
      middleName = '',
      surname,
      jobTitle,
      company,
      logo,
      category,
      name,
      titleSize,
      types = [],
      hideCompanyName,
      commaSeparatorEnabled,
    },
    look,
    brand,
    pageConfig: {
      tenantId,
      siteType,
      tenantConfig: {
        ui: { theme },
      },
    },
    t,
  } = props;

  let section, backgroundImage;
  const personTypes =
    types.length > 0 ? types : [siteType === COURSE ? 'TRAINER' : 'SPEAKER'];

  switch (look) {
    case 'speaker':
      backgroundImage = getImgixUrl(
        tenantId,
        photo?.path,
        'fit=clamp&w=130&h=130',
        '/images/default-silhouette.png',
      );

      section = (
        <section
          className="c-event-section c-event-section--without-padding c-person-header-section"
          style={{
            backgroundColor:
              theme === 'AsiaTechXSG'
                ? brand.darkSecondaryColor
                : brand.secondaryColor,
          }}
        >
          <div
            className="c-person-header-section__top-line"
            style={{ backgroundColor: brand.darkSecondaryColor }}
          />
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <div
                  className="c-person-header-section__photo lazy"
                  data-background-image={backgroundImage}
                />
                <h1>
                  <div className="c-event-section__heading c-person-header-section__name">
                    {displayHonorific && honorific} {forename} {middleName}{' '}
                    {surname}
                  </div>
                  <PersonRole
                    jobTitle={jobTitle}
                    company={company}
                    hideCompanyName={hideCompanyName}
                    commaSeparatorEnabled={commaSeparatorEnabled}
                  />
                  {showType && (
                    <div className="c-person-header-section__type">
                      {personTypes
                        .map((personType) =>
                          t(`event.person.type.${personType}`),
                        )
                        .join(', ')}
                    </div>
                  )}
                </h1>
              </div>
            </div>
          </div>
        </section>
      );
      break;

    case 'sponsor':
      backgroundImage = getImgixUrl(
        tenantId,
        logo?.path,
        'fit=clamp&w=235',
        '/images/default-silhouette.png',
      );

      section = (
        <section
          className="c-event-section c-event-section--color-black c-event-section--without-padding c-person-header-section"
          style={{
            backgroundColor:
              theme === 'AsiaTechXSG' ? brand.darkSecondaryColor : undefined,
          }}
        >
          <div
            className="c-person-header-section__top-line"
            style={{
              backgroundColor:
                theme === 'AsiaTechXSG' ? brand.darkSecondaryColor : undefined,
            }}
          />
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <div
                  className="c-person-header-section__logo lazy"
                  data-background-image={backgroundImage}
                />
                <p className="c-person-header-section__category">{category}</p>
                {name && (
                  <Heading
                    content={name}
                    as={titleSize}
                    headingClass="c-event-section__heading c-person-header-section__company"
                    testId="sponsor-title"
                  />
                )}
              </div>
            </div>
          </div>
        </section>
      );
      break;

    default:
      break;
  }

  return section;
}

PersonHeader.propTypes = {
  data: PropTypes.object,
  look: PropTypes.oneOf(['sponsor', 'speaker']),
  brand: PropTypes.object,
  pageConfig: PropTypes.shape({
    tenantId: PropTypes.string,
    tenantConfig: PropTypes.shape({
      ui: PropTypes.shape({
        theme: PropTypes.string,
      }),
    }),
  }),
};

function mapStateToProps(state) {
  return {
    pageConfig: state.pageConfig,
  };
}

export default withTranslation()(
  connect(mapStateToProps)(withBrand(PersonHeader)),
);
